import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { InvoiceComposer } from "@/features/office/billing/invoices/composer";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  // Where the composer was opened: `order` sends Issue back to the order.
  // A lenient string: a strict enum here takes the page down (webapp-routing.md).
  from: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute(
  "/office/billing/invoices/$invoiceId/edit",
)({
  validateSearch: searchSchema,
  component: InvoiceComposer,
});
